var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"show-hide-text"},[(!_vm.showText)?_c('span',{staticClass:"font-weight-bold"},[_vm._v("············")]):_vm._t("default"),(!_vm.showText)?_c('PrimaryButton',{staticClass:"p-0",attrs:{"shrink":"","text":""},nativeOn:{"click":function($event){_vm.showText = !_vm.showText}}},[_vm._v(" Show ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }